<template>
  <b-row>
    <b-col cols="12">
      <div
        v-if="error"
        class="alert alert-dismissible alert-danger"
        role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true"></span> {{ error }}
      </div>
      <div
        v-if="deleteError"
        class="alert alert-dismissible alert-danger"
        role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true"></span> {{ deleteError }}
      </div>
    </b-col>
    <b-col cols="12">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'SqlScriptExecutedList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <div class="card">
        <template v-if="isLoading">
          <Loader></Loader>
        </template>
        <template v-else>
          <div v-if="item" class="pb-4">
            <p v-if="item.createdAt">
              <b>{{$t('views.application.show.created')}}</b> - {{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}
            </p>
            <p class="mb-0"><b>{{$t('views.sqlscriptexecuted.show.title')}}</b></p>
            <p>{{item.sqlScript}}</p>
          </div>
          <div v-if="item">
            <table class="table table-striped table-hover">
              <thead>
              <tr>
                <th>{{$t('views.application.show.application')}}</th>
                <th>{{$t('views.application.show.executeReturn')}}</th>
                <th>{{$t('views.application.show.executedAt')}}</th>
              </tr>
              </thead>
              <tbody>
<!--            v-for="i in item.documents" :key="i.fileName" > {{i.fileName}}-->
            <tr v-for="i in item.sqlScriptExecutedApplication" :key="i['@id']">
<!--              <b>{{$t('views.application.show.executedAt')}}: </b> <p v-for="i in item.sqlScriptExecutedApplication" :key="i.createdAt">{{i.createdAt}}</p>-->
              <td>
                 <p>{{i.application.subdomain}}.{{i.application.domain.domain}}</p>
              </td>
              <td>
                <p>{{ getFirstPart(i.executeReturn) }}</p>
              </td>
              <td>
                <p>{{i.createdAt}}</p>
              </td>

            </tr>
<!--            <b-table-->
<!--              :fields="executedApplicationFields"-->
<!--              :items="item.sqlScriptExecutedApplication">-->
<!--              <template v-slot:cell(createdAt)="data">-->
<!--                {{$moment(data.item.createdAt).format('YYYY-MM-DD')}}-->
<!--              </template>-->
<!--            </b-table>-->
              </tbody>
              </table>
          </div>
        </template>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { DATETIMEFORMATTYPE } from '@/config/datetimeFormatType'
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'

export default {
  components: {
    Loader
  },
  data () {
    return {
      DATETIMEFORMATTYPE,
      executedApplicationFields: [
        {
          key: 'application',
          label: this.$lang.t('views.application.show.application')
        },
        {
          key: 'executeReturn',
          label: this.$lang.t('views.application.show.executeReturn')
        },
        {
          key: 'createdAt',
          label: this.$lang.t('views.application.show.executedAt'),
          sortable: true
        }
      ]
    }
  },
  computed: mapGetters({
    deleteError: 'sqlscriptexecuted/del/error',
    error: 'sqlscriptexecuted/show/error',
    isLoading: 'sqlscriptexecuted/show/isLoading',
    item: 'sqlscriptexecuted/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    getFirstPart (str) {
      return str.split('-')[0]
    },
    ...mapActions({
      del: 'sqlscriptexecuted/del/del',
      reset: 'sqlscriptexecuted/show/reset',
      retrieve: 'sqlscriptexecuted/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'SqlScriptExecutedList' }))
      }
    }
  }
}
</script>
